import { cx } from '@linaria/core';
import { textColumnCls, verticalPaddingCls } from '@pm2/react-utils';
import { speechSelectors } from '@ui/kit';
import { headingCls, textCls } from './message.base.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const EmptyPage = () => {
  return /*#__PURE__*/jsxs("article", {
    className: cx("gPortal-page", textColumnCls, verticalPaddingCls, speechSelectors.enableSpeech.className),
    children: [/*#__PURE__*/jsx("h1", {
      className: headingCls,
      children: "Siden er tom"
    }), /*#__PURE__*/jsxs("p", {
      className: textCls,
      children: ["Denne side har endnu ikke noget indhold.", /*#__PURE__*/jsx("br", {}), "Vi arbejder dog p\xE5 sagen, s\xE5 kom gerne tilbage igen senere."]
    })]
  });
};

export { EmptyPage };
//# sourceMappingURL=message.empty-page.js.map
